import { Component } from 'react';
import CustomizedTextField from '../../Input/CustomizedTextField';
import { getCurrentFunctionName } from '../../../performanceModeManager';
import { clone } from '../../../utils';

class FormTextField extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.multiline || this.props.isComment ? this.props.question.comment : this.props.subField ? this.props.metaQuestion.type === "integer" ? this.props.question.value_choice : this.props.question.value : this.props.question.single_text,
            timeout: 1,
            typedJustNow: false,
        }
    }

    static getDerivedStateFromProps(props, state) {

        if (state.typedJustNow)
            return state;

        state.value = props.multiline || props.isComment  ? props.question.comment : props.subField ? props.metaQuestion.type === "integer" ? props.question.value_choice : props.question.value : props.question.single_text;
        return state;
    }

    handleChange(e) {
        let value = e.target.value;

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        this.setState({
            value,
            typedJustNow: true,
            typingTimeout: setTimeout(() => {

                let response = clone(this.props.question);

                if (this.props.multiline || this.props.isComment) {
                    response.comment = value;
                } else if (this.props.subField)
                    if (this.props.metaQuestion.type === "integer") {
                        response.value_choice = value;
                    } else {
                        response.value = value;
                    }
                else
                    response.single_text = value;


                this.props.responseValueChange(response);

                this.setState({
                    typedJustNow: false
                })
            }, this.state.timeout)
        });
    }

    onClick = ev => {
        const el = ev.target;
        if (document.activeElement !== el) {
            setTimeout(() => {
                if (el.select)
                    el.select();
            }, 0);
        }
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        return (
            <>
                <CustomizedTextField onChange={this.handleChange.bind(this)}
                    {...this.props.inputProperties}
                    type={this.props.type} value={this.state.value} multiline={this.props.multiline}
                    className={this.props.inputProperties.className + " full_size control-margin-top " + (this.props.inputProperties.disabled ? "light-disabled" : "")}
                    comment={this.props.isComment}
                    onMouseDown={this.props.type === "number" ? this.onClick : null}   
                    onBlur={() => {
                        if (typeof this.props.save === "function") {
                            this.props.save();
                        }                        
                    }}
                    inputProps={{ maxLength: 800 }}             
                />
                <div style={{
                    marginLeft: "5px",
                    fontSize: "0.75rem",
                    color: "#000000ff",
                }}>
                    {this.state.value?.length + "/800" || 0}
                </div>
            </>            
        )
    }
}

export default FormTextField;
